import React, { Component } from 'react';
import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css'; //only needs to be imported once


class CalenderMultiDate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      date_array: [],
      occurrence_id: 0, //for storing the id of the occurrence that the user selected
      occurrence_date: this.props.min_date, //for storing the date of the occurrence that the user selected
      occurrence_date_show: this.props.min_date,
      disabled_date_array: [],
      enabled_date_array: [],
      event_perma: this.props.event_perma
    };
  }

 componentDidMount(){

    fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/occurrence_detail?access_token="+this.props.access_token+"&event_name=" + this.state.event_perma)
      .then(res => res.json())
      .then(
        (result) => {
        	//alert(JSON.stringify(result));
	      	let date1 = new Date(this.props.min_date);
	      	
			let date2 = new Date(this.props.max_date);
			//alert("date2: " + date2);
			let time_diff = Math.abs(date2.getTime() - date1.getTime());
			let diff_days = Math.ceil(time_diff / (1000 * 3600 * 24)); //calculating number of days between start date and end date
			
			let check_date = 0;
			let temp_disabled_date_array = [];
			let temp_enabled_date_array = [];
			let temp_occurrence_id = 0;
			let temp_date_for_array = "";
			let temp_date_to_show = "";
			
			
			for(var i = 0; i < diff_days + 1; i++) { //running loop for each day between min and max day
				
				check_date = 0;

				for(var j = 0; j < result.length; j++) { //running loop for the dates in occurrence table
					let raw_ts = result[j]["start_ts"].replace(' ', 'T') + "+05:30";
					let temp_date_ts = new Date(raw_ts);
					let temp_date_string = temp_date_ts.toDateString();
					
					let temp_date = new Date(temp_date_string); //there was some issue in time comparison, as occurrence table may have time not equal to 0, so making each day with time as 00:00:00 in timestamp
					//let current_date = new Date();
					//alert(current_date);
					//if(temp_date.getTime() > current_date.getTime() && date1.getTime() === temp_date.getTime()){ //disabling old dates also
					if(date1.getTime() === temp_date.getTime()){ //disabling old dates also	
						check_date = 1; //changing the variable if the date matches one in occurrece table
						temp_occurrence_id = result[j]["occurrence_id"];
						temp_date_for_array = temp_date; //this is the date which will be used for comparison later
						temp_date_to_show = temp_date_ts; //this is the date which will be displayed to user later
					}
				}

				if(check_date===0){
					let date_year = date1.getYear();
   					date_year = "20" + (date_year - 100);
   					let date_month = date1.getMonth();
   					let date_num = date1.getDate();
					//temp_disabled_date_array.push("'"+date1+"'"); //pushing it to disabled dates array in case the date didnt match any date in occurrence table
					//alert(date_year);
					temp_disabled_date_array.push(new Date(date_year, date_month, date_num));
				}else{
					temp_enabled_date_array.push({"occurrence_id": temp_occurrence_id, "occurrence_date": temp_date_for_array, "occurrence_date_show": temp_date_to_show });
				}
				date1.setDate(date1.getDate() + 1); //increasing date by one day
			}
			//console.log(temp_enabled_date_array);

	      	this.setState({
	      		disabled_date_array: temp_disabled_date_array,
	      		enabled_date_array: temp_enabled_date_array,
	      		date_array: result
	      	});
	        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
        }
      );

  }

	render() {
		let render_selected_date = new Date(this.props.occurrence_date);
		let render_min_date = new Date(this.props.min_date);
		let render_max_date = new Date(this.props.max_date);

		return (
			<InfiniteCalendar
			   className="calendar_div_infinite"
			   selected={render_selected_date}
			   min={render_min_date} // Minimum month to render
			   minDate={render_min_date} // Minimum selectable date
			   max={render_max_date} // Maximum rendered month
			   maxDate={render_max_date} // Maximum selectable date
			   disabledDates={this.state.disabled_date_array}
			   onSelect={(selectedDate) => this.dateSelected(selectedDate)}
			   theme={{
			      selectionColor: 'rgb(233,86,78)',
			      textColor: {
			        default: '#000',
			        active: '#fff'
			      },
			      weekdayColor: 'rgb(161,161,161)',
			      headerColor: 'rgb(238,238,238)',
			      floatingNav: {
			        background: 'rgba(238,238,238, 0.96)',
			        color: '#e9564e',
			        chevron: '#e9564e'
			      }
			   }}
			/>
		 );
	}

  dateSelected(selectedDate) {
    let occurrence_id = this.state.occurrence_id;
    let occurrence_date = this.state.occurrence_date;
    let occurrence_date_show = this.state.occurrence_date_show;
    for(var i = 0; i < this.state.enabled_date_array.length; i++) {
    	
    	let date = new Date(this.state.enabled_date_array[i]["occurrence_date"]);
    	let date_show = new Date(this.state.enabled_date_array[i]["occurrence_date_show"]);
    	if(selectedDate.getTime() === date.getTime()){
    		
    		occurrence_id = this.state.enabled_date_array[i]["occurrence_id"];
    		occurrence_date = date;
    		occurrence_date_show = date_show;
	        this.setState({
	          occurrence_id: occurrence_id,
	          occurrence_date: occurrence_date,
	          occurrence_date_show: occurrence_date_show
	        });

	        document.getElementById("show_dates_title").click(); //hiding the calendar now after date selection
    	}
    }
    this.props.date_change(occurrence_id, occurrence_date_show, this.props.end_time);
  }

}

export default CalenderMultiDate;


// WEBPACK FOOTER //
// ./src/desktop/desktopMultiDate.js